import { Button } from "@icg360/design-system";

import { AddPolicyModal } from "./add-policy-modal";
import { useAddPolicy, useAddPolicyDataFromEmailLink } from "./hooks";

export const AddPolicy = ({ pressEventFn }: { pressEventFn?: () => void }) => {
  const [addPolicyDataFromEmail] = useAddPolicyDataFromEmailLink();

  const {
    addPolicyData,
    openAddPolicyModal,
    closeAddPolicyModal,
    handleAddPolicySucceeded,
    showAddPolicyModal,
  } = useAddPolicy(addPolicyDataFromEmail);

  const handleOnPress = () => {
    if (pressEventFn) {
      pressEventFn();
    }
    openAddPolicyModal();
  };

  return (
    <>
      <Button
        size="sm"
        appearance="tertiary"
        leadingIcon="AddCircle"
        onPress={handleOnPress}
        data-testid="add-policy-btn"
      >
        Add policy
      </Button>
      <AddPolicyModal
        show={showAddPolicyModal}
        handleClose={closeAddPolicyModal}
        onAddPolicySuccess={handleAddPolicySucceeded}
        data={addPolicyData}
      />
    </>
  );
};
